import { render } from "./scene.vue?vue&type=template&id=21143f60&scoped=true"
import script from "./scene.vue?vue&type=script&lang=js"
export * from "./scene.vue?vue&type=script&lang=js"

import "./scene.vue?vue&type=style&index=0&id=21143f60&lang=scss&scoped=true"

import exportComponent from "D:\\changDa\\w3c\\www-clothing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21143f60"]])

export default __exports__